import * as React from 'react';

import {FeatureGateModalWrapper} from './feature-gate-modal-wrapper';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function AccountHierarchyFeatureGateModal(props: Props) {
    return (
        <FeatureGateModalWrapper
            title='Unlock company hierarchy'
            description='Use Nutshell to organize and connect parent / child relationships between companies.'
            bullets={[
                'Connecting parent and child companies unlocks a unified view of data for your entire organization.',
                'View all related data including leads and sales, all in one place for better decision-making.',
                'Quickly set up or adjust parent-child relationships in just a few clicks to start tracking key metrics instantly.',
            ]}
            feature='companyHierarchy'
            {...props}
        />
    );
}
